



























import { Component, Vue } from "vue-property-decorator";
import { deleteAuthorization } from "@/services/authorizations/authorizationService";

@Component
export default class AuthorizationDeleteModal extends Vue {
    authorizationToBeDeleted: string = "";
    authorizationName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(authorizationId: string, name: string) {
        this.authorizationToBeDeleted = authorizationId;
        this.authorizationName = name;
        this.$bvModal.show("modal-deleteAuthorization");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteAuthorization");
        this.authorizationName = "";
        this.authorizationToBeDeleted = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteAuthorization(this.authorizationToBeDeleted).then(() => {
            this.$emit("reload");
            this.authorizationName = "";
            this.authorizationToBeDeleted = "";
            this.$bvModal.hide("modal-deleteAuthorization");
        });
    }
}
